/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsInputDevice: {
  name: 'input-device';
  data: string;
} = {
  name: 'input-device',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 4a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H4Zm0 2h16v8H4V6Zm15 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm-3-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM5 18a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2H5Z" fill="currentColor"/></svg>`,
};
